module.exports = __webpack_public_path__ + "static/img/earth2.c8b1600d.jpg";